import { Flex } from '@mantine/core';
import {
	ACCEPT_FILES_TYPES,
	DropzoneV2,
} from '@dealstack/frontend/shared/components/DropzoneV2/DropzoneV2';
import type { KycFileCertificationChoiceDto } from '@dealstack/shared/lib/generated';
import { CertificationChoiceFields } from './CertificationChoiceFields';
import { certificationChoiceDefaults } from './CertifiableProof.utils';
import { useCertificationChoiceForm } from './useCertificationChoiceForm';

interface Props {
	certificationRequired: boolean;
	onDropFile: (file: File, certification?: KycFileCertificationChoiceDto) => void;
	loading?: boolean;
	multiple?: boolean;
	size?: 's' | 'STD';
	dataTestId?: string;
}

/**
 * DC-825: the proof dropzone. When the programme wants the proof certified, the investor says how
 * before they can upload, and the choice travels with the upload.
 */
export const CertifiableProofUpload = ({
	certificationRequired,
	onDropFile,
	loading,
	multiple = false,
	size,
	dataTestId,
}: Props) => {
	const { form, mode, choice } = useCertificationChoiceForm(certificationChoiceDefaults());

	const dropzone = (
		<DropzoneV2
			onDropFile={(file) => {
				if (!certificationRequired) {
					onDropFile(file);
				} else if (choice) {
					onDropFile(file, choice);
				}
			}}
			multiple={multiple}
			accept={ACCEPT_FILES_TYPES.imagesAndPdf}
			loading={loading}
			size={size}
			disabled={certificationRequired && !choice}
			dataTestId={dataTestId}
		/>
	);

	if (!certificationRequired) {
		return dropzone;
	}

	return (
		<Flex direction="column" gap="0.75rem">
			<CertificationChoiceFields control={form.control} mode={mode} disabled={loading} />
			{dropzone}
		</Flex>
	);
};
